import config from './config.json';


const env = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;

export const ContractBaseUrl = (() => {
    switch (env) {
      case "production":
        return config.production_azure_contract;
      case "staging":
        return config.stage_azure_contract;
      default:
        return config.stage_azure_contract;
    }
  })();

  export const NetworkBaseUrl = (() => {
    switch (env) {
      case "production":
        return config.production_azure_mediation;
      case "staging":
        return config.stage_azure_mediation;
      default:
        return config.stage_azure_mediation;
    }
  })();



// WEBPACK FOOTER //
// ./src/api/utils.js